<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter">
<p class="h1" id="d7e1213442" style="color: #82a339"><b>BAKED RICOTTA <br/> WITH TOMATO VINAIGRETTE</b></p>
<p class="ext" id="d7e1214242"><b><i>Once baked and allowed to set, the squares of ricotta cheese make a nice substitute for medallions of goat cheese or even polenta wedges.</i></b></p>
<p class="h4" id="d7e1215542" style="color: #496210"><b>Prep: 15 minutes plus standing       Bake: 1 hour</b></p>
<p class="ul" id="d7e1216042">2 lemons</p>
<p class="ul" id="d7e1216342">1 container (32 ounces) part-skim ricotta cheese</p>
<p class="ul" id="d7e1216642">¾ teaspoon salt</p>
<p class="ul" id="d7e1217542">⅜ teaspoon ground black pepper</p>
<p class="ul" id="d7e1218542">½ teaspoon Dijon mustard</p>
<p class="ul" id="d7e1219442">¼ cup olive oil</p>
<p class="ul" id="d7e1220442">4 plum tomatoes, coarsely chopped</p>
<p class="ul" id="d7e1220742">1 bag (5 to 6 ounces) baby greens</p>
<p class="pub" id="d7e1221242" style="margin-top: 1.5em;"><span style="color: #c15b49"><b>1.</b></span> Preheat oven to 375°F. From lemons, grate 1 teaspoon peel and squeeze 3 tablespoons juice. Set aside. Spray 9-inch glass or ceramic pie plate with nonstick cooking spray.</p>
<p class="pub" id="d7e1223142"><span style="color: #c15b49"><b>2.</b></span> In medium bowl, stir lemon peel, ricotta, ½ teaspoon salt, and ¼ teaspoon pepper until blended. Spread ricotta mixture evenly in prepared pie plate. Bake 1 hour or until cheese is lightly browned. Let stand 10 minutes to allow cheese to set. Slice into 12 wedges.</p>
<p class="pub" id="d7e1227542"><span style="color: #c15b49"><b>3.</b></span> Meanwhile, in medium bowl, whisk together lemon juice, Dijon, ¼ teaspoon salt, and ⅛ teaspoon pepper. Whisk in olive oil in slow steady stream until blended. Stir in chopped tomatoes.</p>
<p class="pub" id="d7e1230942"><span style="color: #c15b49"><b>4.</b></span> To serve, place 1 ricotta wedge along with some greens on each of 12 serving plates. Top greens and ricotta with tomato vinaigrette. Makes 12 first-course servings.</p>
<p class="ntx" id="d7e1232942">Each serving: About 155 calories, 9g protein, 6g carbohydrate, 11g total fat (4g saturated), 1g fiber, 23mg cholesterol, 245mg sodium.</p>
<p class="ser"><img alt="9781618371621_0042_001" src="Images/9781618371621_0042_001.jpg" style="max-width:100%;"/></p>
<p class="cap" id="d7e1234142"><i>Baked Ricotta with Tomato Vinaigrette</i></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// West_9781618371621_epub_c31_r1.vue?583828bf